import { render, staticRenderFns } from "./GoogleButtonComponent.vue?vue&type=template&id=5c443fe8&"
import script from "./GoogleButtonComponent.vue?vue&type=script&lang=js&"
export * from "./GoogleButtonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports